import i18n from '@/i18n';
const $t = (text) => {
  return i18n.global.t(text);
};
export const logSetup = [
  {
    id: 'logName',
    text: $t('label.fileName'),
    value: 'service.type',
    width: 250,
    minWidth: 115,
    sortable: true,
    bodyAlign: 'left',
    isVisible: true
  },
  {
    id: 'logPath',
    text: $t('label.filePath'),
    value: 'log.file.path',
    width: 260,
    minWidth: 90,
    sortable: true,
    bodyAlign: 'left',
    isVisible: true
  },
  {
    id: 'logMetrics',
    text: $t('label.logMetrics'),
    value: 'logMetrics',
    width: 260,
    minWidth: 100,
    sortable: false,
    bodyAlign: 'left',
    isVisible: true
  }
];
